import { z } from 'zod';
import { AccountIdSchema, PlayerIdSchema, SessionIdSchema } from '../ids';
import { TimestampMsSchema } from '../time';

/** A signed-in account; `playerId` is the character chosen to play, if any (ADR 0029). */
export const SessionSchema = z.object({
  id: SessionIdSchema,
  accountId: AccountIdSchema,
  playerId: PlayerIdSchema.nullable(),
  createdAt: TimestampMsSchema,
  expiresAt: TimestampMsSchema,
});
export type Session = z.infer<typeof SessionSchema>;

/** Opaque bearer credential. Only its hash is stored by the server. */
export const SessionTokenSchema = z.string().min(32).max(128);
export type SessionToken = z.infer<typeof SessionTokenSchema>;
